import { createContext, useContext } from 'react';

import { readShigoAppConfig } from '../../lib/config';
import type { ResolvedNetworkBranding } from '../../lib/networkBranding';

export const NetworkBrandingContext = createContext<ResolvedNetworkBranding | null>(null);

export function useNetworkBranding() {
  const branding = useContext(NetworkBrandingContext);
  if (branding) return branding;
  const config = readShigoAppConfig();
  return {
    displayName: config.displayName,
    logoUrl: config.logoUrl,
    logoLightUrl: config.logoLightUrl,
  };
}
